'use strict';

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { find } from 'lodash';
import { doRedirect } from '../../data/service/tayspolku/actions';
import WindowUtils from '../../utils/WindowUtils';
import { withPageBase } from '../../components/PageBase';
import Alert from '../../components/Alert';
import Loader from '../../components/Loader';
import {
  compareStatus,
  KAYTTAJA,
  PYYDETTY,
} from '../../definitions/PolkuConstants';
import { Link } from 'react-router-dom';

/*
 * Redirects user to an external URL, where user can download TaysPolku app.
 * See omatays-service/src/main/resources/tayspolku/README.md.
 * */

const TaysPolkuRedirect = (props) => {
  const { taysPolku, doRedirect, integrations } = props;

  WindowUtils.clearSessionStorage();

  const [urlError, setUrlError] = useState(false);

  if (integrations.isFetching) {
    return <Loader />;
  }

  const taysPolkuObject = find(integrations.data, { name: 'Tays polku' });

  if (!taysPolkuObject) {
    return (
      <Alert message={`tayspolku.Redirect.js.error`}>
        {' '}
        <Link to={'/'} className={'alert-link'}>
          Palaa OmaTaysin etusivulle
        </Link>
      </Alert>
    );
  }

  useEffect(() => {
    if (taysPolku.url !== '' && taysPolku.url !== null) {
      if (!taysPolku.isFetching) {
        WindowUtils.navigate(taysPolku.url);
      }
    }
  }, [taysPolku.url]);

  useEffect(() => {
    doRedirect();
  }, []);

  useEffect(() => {
    if (taysPolku.error !== null) {
      setUrlError(true);
    }
  }, [taysPolku.error]);

  if (taysPolku.isFetching) {
    return <Loader />;
  }

  if (urlError) {
    return <Alert message={`tayspolku.Redirect.js.urlerror`} />;
  }

  return (
    <>
      <FormattedMessage id={`tayspolku.Redirect.js.message`}>
        {(txt) => <p>{txt}</p>}
      </FormattedMessage>
      <a className={`tayspolku-link`} href={taysPolku.url}>
        Sovellukseen
      </a>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    taysPolku: state.services.taysPolku,
    integrations: state.services.integrations,
  };
};

export default withPageBase(
  connect(mapStateToProps, { doRedirect })(TaysPolkuRedirect),
  { title: '' }
);
